/** Outreach activities that count toward "worked the lead" after a due follow-up. */
export const FOLLOW_UP_OUTREACH_ACTIVITY_TYPES = [
  'sms_sent',
  'email_sent',
  'phone_call',
  'proposal_sent',
] as const;

export interface FollowUpPromptOpportunityFields {
  status: string;
  next_follow_up_at?: string | null;
  initial_follow_up_prompt_dismissed_at?: string | null;
  follow_up_due_prompt_dismissed_for_due_at?: string | null;
}

export type FollowUpClosePromptReason = 'fresh' | 'due_after_activity';

export function hasActiveFutureFollowUp(
  nextFollowUpAt: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!nextFollowUpAt) return false;
  const due = new Date(nextFollowUpAt);
  return !Number.isNaN(due.getTime()) && due.getTime() > now.getTime();
}

export function getFollowUpClosePromptReason(
  opportunity: FollowUpPromptOpportunityFields,
  hasOutreachAfterDue: boolean,
  now: Date = new Date(),
): FollowUpClosePromptReason | null {
  if (opportunity.status !== 'Open') return null;
  if (hasActiveFutureFollowUp(opportunity.next_follow_up_at, now)) return null;

  const dueAt = opportunity.next_follow_up_at;
  const dueMs = dueAt ? new Date(dueAt).getTime() : NaN;
  const isDueOrPast = !Number.isNaN(dueMs) && dueMs <= now.getTime();

  if (isDueOrPast && hasOutreachAfterDue) {
    if (opportunity.follow_up_due_prompt_dismissed_for_due_at === dueAt) {
      return null;
    }
    return 'due_after_activity';
  }

  if (!opportunity.initial_follow_up_prompt_dismissed_at) {
    return 'fresh';
  }

  return null;
}
